
const getBookingUrl = (lat: number, long: number, zoom: number): string => {
    const radius = 100; // TODO what is algorithm of changing radius into zoom?
    return "https://www.booking.com/searchresults.html?aid=310680&amp;latitude=" + lat + "&amp;longitude=" + long + "&amp;radius=" + radius
}

export default getBookingUrl